// A person's phone number, trimmed — people records carry it under any of these keys.
export const personPhone = (person) => (person?.phone || person?.phoneNumber || person?.mobile || '').trim();
